import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=2aba845d&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=2aba845d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba845d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aba845d')) {
      api.createRecord('2aba845d', component.options)
    } else {
      api.reload('2aba845d', component.options)
    }
    module.hot.accept("./LoadingIndicator.vue?vue&type=template&id=2aba845d&scoped=true&", function () {
      api.rerender('2aba845d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/LoadingIndicator.vue"
export default component.exports